import Track from "../webPage/Track";
import TestimonialSliderModal from "../modal/TestimonialSliderModal";

export default function handleTestimonialSliders(){
    let $slider = $('.js-slider');

    if ($slider.length > 0) {
        $slider.each(function (index, el) {
            new Track($(el), {
                classes: {
                    block: "slider",
                },
                navigateItemCount: 3
            });
        });
    }

    $('body').on('click', '.js-read-testimonial', function(){
        let clone = $(this).closest('.js-testimonial-card').clone();
        let modal = new TestimonialSliderModal(clone);
        modal.show();

        return false;
    });
}
